import * as React from 'react';
import { createStyles } from "@mantine/core";


interface TableIndicatorProps {
    active: boolean;
    color?: string;
}

const TableIndicator = ({
    active,
    color
}: TableIndicatorProps) => {

    const { classes } = useStyles();

    let className = `${classes.indicator} ${active ? classes.active : classes.inactive}`;
    return (
        <div className={className} style={{ backgroundColor: color ? color : undefined }}/>
    )
}

const useStyles = createStyles(() => {
    return {
        indicator: {
            width: 10,
            height: 10,
            borderRadius: '50%',
        },
        active: {
            background: '#09bd09'
        },
        inactive: {
            background: 'gray',
        }
    }
})

export default TableIndicator